import { orderHistory } from "@/core/reatom/state/orders/orders";
import { Block } from "../Block/Block";
import s from "./style.module.scss";
import { useAtom } from "@reatom/npm-react";
import dayjs from "dayjs";
import "dayjs/locale/ru";

dayjs.locale("ru");
export const OrderHistory = () => {
  const [history] = useAtom(orderHistory);
  function decodeHtmlEntities(text: string): string {
    const txt = document.createElement("textarea");
    txt.innerHTML = text;
    return txt.value;
  }
  return (
    <Block>
      <div>
        <p className={s.title}>История изменений заказа</p>
        <div className={s.wrapper}>
          {history?.items.map((item, index) => (
            <div key={index} className={s.line}>
              <p className={s.date}>
                {dayjs(item.time).format("DD.MM.YYYY в HH:mm")}
              </p>
              <p className={s.description}>{decodeHtmlEntities(item.text)}</p>
            </div>
          ))}
        </div>
      </div>
    </Block>
  );
};
